<template>
    <div>
        <div v-for="field in fields">
            <component v-if="getFieldComponent(field) !== null && field.hiddenInRoot === undefined"
                       class="mb-5"
                       :field="field"
                       :data="data"
                       :is="getFieldComponent(field)">
            </component>

            <component class="mt-5"
                       :is="getPath(field).suggestion"
                       :field="field"
                       v-if="getPath(field) && getPath(field).suggestion !== undefined">
            </component>

            <hr v-if="getPath(field) && getPath(field).addHr" class="mb-5">
        </div>
    </div>
</template>

<script>
import { typeComponents, fieldsMapping } from "../../../static/webform"
import {mapGetters} from "vuex"

import AddressSuggestion from "./suggestion/AddressSuggestion.vue"
import CommunicationSuggestion from "./suggestion/CommunicationSuggestion.vue"
import PlatformSuggestion from "./suggestion/PlatformSuggestion.vue"
import MediaSuggestion from "./suggestion/MediaSuggestion.vue"
import OpeningPeriodSuggestion from "./suggestion/OpeningPeriodSuggestion.vue"

import FormText from "./form-components/FormText.vue"
import FormTextarea from "./form-components/FormTextarea.vue"
import FormNumeric from "./form-components/FormNumeric.vue"
import FormSelect from "./form-components/FormSelect.vue"
import FormGeo from "./form-components/FormGeo.vue"
import FormCity from "./form-components/FormCity.vue"
import FormCommunication from "./form-components/FormCommunication.vue"
import FormMedia from "./form-components/media/FormMedia.vue"
import FormRadio from "./form-components/FormRadio.vue"
import FormDate from "./form-components/FormDate.vue"
import FormOpeningPeriod from "./form-components/opening-period/FormOpeningPeriod.vue"
import FormPricePeriod from "./form-components/price-period/FormPricePeriod.vue"
import FormContactCity from "./form-components/FormContactCity.vue"

export default {
    name: "FormComponentLoader",
    props: ['fields', 'data'],
    components: {
        FormText, FormTextarea, FormNumeric, FormSelect, FormGeo, FormCity, FormCommunication, FormMedia, FormRadio,
        FormDate, FormOpeningPeriod, FormPricePeriod, AddressSuggestion, CommunicationSuggestion, PlatformSuggestion,
        MediaSuggestion, OpeningPeriodSuggestion, FormContactCity
    },
    methods: {
        getFieldComponent(field) {
            let path = this.getPath(field)
            if (path && path.type !== undefined) {
                let typeComponent = typeComponents.find(component => component.type === path.type)
                if (typeComponent !== undefined) {
                    return typeComponent.component
                }
            }

            let typeComponent = typeComponents.find(component => component.type === field.type)

            return typeComponent !== undefined ? typeComponent.component : null
        },
        getPath(field) {
            let code = this.getCodeFromField(field)

            return fieldsMapping.find(path => path.code === code)
        }
    },
    computed: {
        ...mapGetters('web_form', ['getCodeFromField'])
    }
}
</script>